"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _keycodes = _interopRequireDefault(require("../../util/keycodes"));

var _modal = _interopRequireDefault(require("./templates/modal.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Modal =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(Modal, _Backbone$View);

  function Modal() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.isSelectEvent = function (e) {
      return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
    }, _temp));
  }

  _createClass(Modal, [{
    key: "initialize",
    value: function initialize(options) {
      _.extend(this, this.defaults, options);

      this.tpl = _modal["default"];
      this.setElement(this.tpl(this));

      if (this.id.length) {
        this.$el.attr('id', this.id);
      }

      this.$content = this.$el.find('.modal-container');
      this.$content.empty().append(this.content);
      this.$el.addClass(this.classes.join(' '));
      this.$title = this.$el.find('.modal-title');

      if (this.hiddenTitle) {
        this.$title.css("opacity", "0");
      }

      if (this.autoRender) {
        this._render();
      }

      this._bindEvents();
    }
  }, {
    key: "_render",
    value: function _render() {
      if (this.attachToDocument) {
        // For Foundation to work as expected we need to have the element attached to the DOM before calling .foundation('reveal', 'open')
        $('body').append(this.el);
      }

      if (this.autoShow) {
        this.show();
      }

      return this;
    }
  }, {
    key: "_bindEvents",
    // We dont actually want to use the Foundation modal events since they get weird fast...
    // lets use our own so consumers dont have to know its foundation
    value: function _bindEvents() {
      var _this2 = this;

      this.$el.on('click keydown', '.js-close', function (e) {
        _this2.isSelectEvent(e) && _this2.trigger('cancel', _this2);
      });

      if (this.defaultButtonBehaviour) {
        this.on('close cancel', function () {
          _this2.close();
        });
      }

      this.$el.on('keypress', '*', function (e) {
        if (e.which === _keycodes["default"].TAB) {
          _this2._keepFocus(e);
        }
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      this._beforeShow();

      this.$el.foundation('reveal', 'open');
      this.trigger('show', this);
      this.$el.on('keydown', function (e) {
        _this3._keepFocus(e);
      }); // Execute code after the modal is displayed

      this.$el.on('opened.fndtn.reveal', function () {
        return _this3._afterShow();
      }); // Traps foundation bug that closes modal on dropdown "closed", not an issue in 5.5.3+

      this.$el.off('closed'); // Handle foundation  close events from ESC and BG clicks

      this.$el.on('close.fndtn.reveal', function () {
        _this3.$el.off('close.fndtn.reveal');

        _this3.trigger('close');
      });
    }
  }, {
    key: "_beforeShow",
    value: function _beforeShow() {
      this.focused = $(document.activeElement);
    }
  }, {
    key: "_afterShow",
    value: function _afterShow() {
      this.$el.attr('aria-hidden', false);
      $('.container').attr('aria-hidden', 'true');
      $('.row.footer').attr('aria-hidden', 'true');
      $('.nav-container').attr('aria-hidden', 'true');
      this.$title.focus();

      this._setScroll();
    }
  }, {
    key: "_setScroll",
    value: function _setScroll() {
      var offset = window.pageYOffset - parseInt(this.$el.css('top').slice(0, -2), 10); // the 'top' styling is baked in by foundation

      if (window.innerHeight < this.el.offsetHeight - offset) {
        // scroll tall modals into view as much as fits
        offset = Math.min(this.el.offsetHeight - window.innerHeight + 10, -5);
      } else if (window.innerWidth < 641) {
        // mobile view padding
        offset -= 5;
      }

      this.el.scrollIntoView(); // sets scroll to top of modal

      window.scrollBy(0, offset); // adjusts scroll according to calculated offset
    }
  }, {
    key: "_keepFocus",
    value: function _keepFocus(e) {
      var activeElem = $(document.activeElement);
      var firstFocusable = this.$title || this.$el.find(':focusable:visible').first();
      var lastFocusable = this.$el.find(':focusable:visible').last();

      if (activeElem.is(firstFocusable) && e.which === _keycodes["default"].TAB && e.shiftKey) {
        e.preventDefault();
        lastFocusable.focus();
      } else if ($(activeElem).is(lastFocusable) && e.which === _keycodes["default"].TAB && !e.shiftKey) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.foundation('reveal', 'close');
      this.trigger('hide', this);
      $('.container').attr('aria-hidden', 'false');
      $('.row.footer').attr('aria-hidden', 'false');
      $('.nav-container').attr('aria-hidden', 'false');
      this.focused.focus();
    }
  }, {
    key: "close",
    value: function close() {
      this.hide();
      this.remove();
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        autoShow: true,
        autoRender: true,
        closeOnEsc: true,
        closeOnBlur: true,
        id: '',
        classes: ['small'],
        buttonAlign: 'right',
        title: 'Title',
        hiddenTitle: false,
        content: 'Some Content',
        submitText: html('ok'),
        cancelText: html('cancel'),
        attachToDocument: true,
        defaultButtonBehaviour: true,
        showCloseButton: true
      };
    }
  }]);

  return Modal;
}(Backbone.View);

exports.Modal = Modal;